
const products_on_page = document.getElementById('product-grid');
let next_url = document.getElementById('paginateNext').dataset.nextUrl;

const load_more_btn = document.querySelector('.load-more_btn');
const load_more_spinner = document.querySelector('.load-more_spinner');

async function getNextPage() {
  try {
    let res = await fetch(next_url);
    return await res.text();
  } catch (error) {
    console.log(error);
  }
}

async function loadMoreProducts() {
  load_more_btn.style.display = 'none';
  load_more_spinner.style.display = 'block';

  let nextPage = await getNextPage();
  const parser = new DOMParser();
  const nextPageDoc = parser.parseFromString(nextPage, 'text/html');
  
  load_more_spinner.style.display = 'none';

  const productgrid = nextPageDoc.getElementById('product-grid');
  const new_products = productgrid.querySelectorAll('.grid__item');

  const nextUrlElement = nextPageDoc.querySelector('#paginateNext');
  next_url = nextUrlElement ? nextUrlElement.dataset.nextUrl : null;

  if (!next_url) {
    load_more_btn.style.display = 'none';
  } else {
    load_more_btn.style.display = 'flex';
  }

  new_products.forEach(p => products_on_page.appendChild(p));
}
